<template>
  <v-card
    flat
    :outlined="guid && (succeeded || loading)"
    :loading="loading"
    class="mx-2 my-0"
    v-if="settings.relatedNoteEnabled"
  >
    <template slot="progress">
      <v-progress-linear
        :color="$vuetify.theme.dark ? 'white' : 'grey'"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-card-text class="px-1 pb-0 pt-1 mx-0">
      <v-row v-if="loading" class="my-1">
        <v-col align="center">読み込み中...</v-col>
      </v-row>
      <v-row v-if="failed" class="my-1">
        <v-col align="center">（関連ノートが読み込めません）</v-col>
      </v-row>
      <!-- <v-row v-if="!loading && relatedNotes.length == 0">
        <v-col align="center">読み込み中...</v-col>
      </v-row> -->
      <template v-if="!loading && relatedNotes.length">
        <v-row no-gutters class="my-1" @click="onExpand">
          <v-col class="ml-2">関連ノート</v-col>
          <v-col cols="1" align="right">
            <v-btn @click.stop="onExpand" icon small class="mt-n1"
              ><v-icon>{{ expanded ? 'mdi-minus' : 'mdi-plus' }}</v-icon></v-btn
            ></v-col
          ></v-row
        >
        <v-list flat dense color="transparent" class="py-0 ">
          <RelatedNote
            :relatedNotes="relatedNotesHeadline"
            :noteViews="noteViews"
            @clickInNew="clickInNew"
          />
          <v-expand-transition>
            <RelatedNote
              :relatedNotes="relatedNotesRest"
              :noteViews="noteViews"
              v-show="expanded"
              @clickInNew="clickInNew"
            />
          </v-expand-transition>
        </v-list>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import evernote from '@/services/EvernoteService'
import dateService from '@/services/DateService'
import utility from '@/services/UtilityService'
import stateService from '@/services/StateService'
import noteViewsService from '@/services/NoteViewsService'
import settings from '@/services/SettingsService'
import RelatedNote from '@/components/parts/RelatedNote'

export default {
  props: {
    guid: {
      type: String
    }
  },
  components: {
    RelatedNote
  },
  computed: {
    dateService: () => dateService,
    settings: () => settings,
    utility: () => utility,
    loading: vm => vm.context.state === vm.context.Processing,
    succeeded: vm => vm.context.state === vm.context.Succeeded,
    failed: vm => vm.context.state === vm.context.Failed,
    relatedNotesHeadline: vm => vm.relatedNotes.slice(0, 2),
    relatedNotesRest: vm => vm.relatedNotes.slice(2)
  },
  data() {
    return {
      relatedNotes: [],
      noteViews: {},
      context: undefined,
      expanded: false
    }
  },
  mounted() {
    this.expanded = settings.relatedNoteExpanded
    this.loadRelatedNotes()
  },
  created() {
    this.context = stateService.createContext({
      Exception: {
        message:
          'ネットワークエラーが発生しました。インターネットに接続しているか確認してみてください。'
      }
    })
  },
  watch: {
    guid() {
      this.loadRelatedNotes()
    },
    relatedNotes(value) {
      this.setupNoteViews(value)
    }
  },
  methods: {
    async setupNoteViews(notes) {
      const noteViews = {}
      await Promise.all(
        notes.map(async note => {
          noteViews[note.guid] = await noteViewsService.count(note.guid)
        })
      )
      this.noteViews = noteViews
    },
    // onNote(note) {
    //   this.$emit('click', note)
    // },
    clickInNew(note) {
      this.$emit('clickInNew', note)
    },
    loadRelatedNotes() {
      if (!settings.relatedNoteEnabled) {
        // console.log('[INFO] skip load related notes.')
        return
      }
      this.relatedNotes = []
      if (this.guid) {
        // console.log('loading related notes...')
        evernote
          .relatedNotes(this.guid, () => {
            this.context.changeStateTo(this.context.Processing)
          })
          .then(notes => {
            // this.relatedNotes = notes.slice(0, settings.relatedNoteLength) // ここで表示件数を絞る
            this.relatedNotes = notes
            this.context.changeStateTo(this.context.Succeeded)
          })
          .catch(error => {
            this.context.changeStateTo(this.context.Exception, error.toString())
          })
      }
    },
    onExpand() {
      this.expanded = !settings.relatedNoteExpanded
      settings.relatedNoteExpanded = this.expanded
    }
  }
}
</script>

<style scoped></style>
